import * as api from '../api'

export const getUser=()=>async(dispatch)=>{

    try{
        const Userlist =await api.Userlist();
        //console.log(Userlist.data)
        dispatch({type:'FETCH_USER',payload:Userlist})
    }catch(error){
        console.log(error.message)
    }
}